import { render, staticRenderFns } from "./OriginalTable.vue?vue&type=template&id=8ab02e18&scoped=true&"
import script from "./OriginalTable.vue?vue&type=script&lang=js&"
export * from "./OriginalTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab02e18",
  null
  
)

export default component.exports